// extracted by mini-css-extract-plugin
export var authorDetails = "blogCard-module--authorDetails--e9b3f";
export var authorImage = "blogCard-module--authorImage--58a9c";
export var authorImageFrame = "blogCard-module--authorImageFrame--ed244";
export var authorName = "blogCard-module--authorName--c93b3";
export var authorRow = "blogCard-module--authorRow--ec11a";
export var blogCard = "blogCard-module--blogCard--a53d0";
export var cardImageAnimation = "blogCard-module--cardImageAnimation--4c8fd";
export var categoryButton = "blogCard-module--categoryButton--4661d";
export var dark = "blogCard-module--dark--4794c";
export var excerpt = "blogCard-module--excerpt--4612a";
export var featuredKlaviyoLogo = "blogCard-module--featuredKlaviyoLogo--6ae99";
export var image = "blogCard-module--image--83c6d";
export var imagePlaceholderContainer = "blogCard-module--imagePlaceholderContainer--3834f";
export var klaviyoLogo = "blogCard-module--klaviyoLogo--0df94";
export var light = "blogCard-module--light--995ce";
export var readTime = "blogCard-module--readTime--d64e8";
export var title = "blogCard-module--title--d06e5";